export const PORT = 3001;
//export const URL = 'http://localhost:3001';
export const URL = "https://musclelabii.onrender.com";
export const fulfilled = "fulfilled";
export const pending = "loading";
export const rejected = "rejected";
export const weekDays = [
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
  "Domingo",
];
export const clientId =
  "1060018757623-sk8opucj3l59lu8u1e6qmsuggnqtgr0h.apps.googleusercontent.com";